import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { ButtonFunction } from '@snack-uikit/button';
import { ChevronDownSVG } from '@snack-uikit/icons';
import { TEST_IDS } from '../../testIds';
import styles from './styles.module.css';
import { stopPropagationClick } from './utils';
export function CollapseBlockHeaderContainer({ children, toggleExpanded, expanded, actions, }) {
    const functionLayoutRef = useRef(null);
    const [width, setWidth] = useState('0px');
    useEffect(() => {
        setWidth(() => {
            if (functionLayoutRef.current) {
                return getComputedStyle(functionLayoutRef.current, null).getPropertyValue('width');
            }
            return '0px';
        });
    }, [functionLayoutRef]);
    const handleToggleExpanded = () => toggleExpanded(!expanded);
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _jsxs("div", { className: styles.header, "data-test-id": TEST_IDS.header, onClick: handleToggleExpanded, children: [_jsx("div", { className: styles.text, style: { '--width': width }, children: children }), _jsxs("div", { className: styles.functionLayout, ref: functionLayoutRef, onClick: stopPropagationClick, children: [actions, _jsx(ButtonFunction, { className: styles.button, "data-expanded": expanded || undefined, icon: _jsx(ChevronDownSVG, {}), onClick: handleToggleExpanded, size: 'xs', "data-test-id": TEST_IDS.chevron })] })] }));
}
